module.exports = __webpack_public_path__ + "static/media/icon-alert-red.e6b765f6.svg";